module.exports = __webpack_public_path__ + "static/garmin_cycling_coach_mobile-ff33be20e8d11d82196c63548c85a173.jpg";